import { useQuery } from '@tanstack/react-query';
import { BotsActivityOverviewResponse } from '../../../types/bots-activity/BotsActivityOverviewResponse';
import { getOverview } from '../../../services/bots-activity/BotsActivityService';
import { GET_BOTS_ACTIVITY_OVERVIEW } from '../../query/bots-activity/keys';

export const useGetBotsActivityOverview = (projectId: number | null, range: string) => {
  const queryEnabled = !!projectId;

  const { data, isLoading, isError, refetch } = useQuery<BotsActivityOverviewResponse>({
    queryKey: [GET_BOTS_ACTIVITY_OVERVIEW, projectId, range],
    queryFn: () => getOverview(projectId!, range),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    enabled: queryEnabled,
  });

  return {
    data,
    isLoading: queryEnabled ? isLoading : false,
    isError,
    refetch,
  };
};
